import Text from "@src/lib/ui/Text";
import Widget from "@src/features/home/Widget";
import { Skeleton } from "@src/lib/ui/Skeleton";
import { useGetInactiveUserCounts } from "@src/features/home/hooks/useGetInactiveUsersCounts";
import InactiveUsersSheet from "@src/features/home/InactiveUsersSheet";
import UsersOutlineIcon from "@src/lib/icons/18px/users-outline";

const InactiveUsersWidget: React.FC = () => {
  const { data, loading } = useGetInactiveUserCounts();
  const inactiveUserCount = data?.People.totalCount || 0;
  return (
    <Widget
      title="Inactive"
      className="flex-1 self-stretch shadow-none"
      Icon={UsersOutlineIcon}
    >
      {loading && !data ? (
        <Skeleton className="h-[34px] w-10 rounded-md" />
      ) : (
        <div className="flex flex-row items-center gap-1 align-middle">
          <InactiveUsersSheet>
            <Text
              variant="display-bold"
              className="cursor-pointer hover:underline"
            >
              {inactiveUserCount}
            </Text>
          </InactiveUsersSheet>
        </div>
      )}
    </Widget>
  );
};

export default InactiveUsersWidget;
